define('ordersDetailAttachmentsOrderView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'settings',
  'attachmentsView',
  'compositionPickerView',
  'entities/customers/customers'
], function(
  App,
  Module,
  _,
  $,
  Settings,
  AttachmentsView,
  CompositionPickerView
) {
  'use strict';

  Module.exports = AttachmentsView.extend({

    setConfig() {
      return {
        galleryTitle: 'Order Attachment',
        canCopy: Settings.configValue('order.attachments.showCustomerAttachments') ? true : false,
        copyButton: {
          title: _.i18n('orders.detail.attachments.order.copy-button.title')
        },
        canFlag: true,
        canApplyToComposition: true,
        canAiEdit: true
      };
    },

    aiEditItem: function(attachment) {
      this.openAiEditChat(this.model.get('purchaseOrderId'), attachment);
    },
   
    getPrintAreas: function() {
      return this.printAreasFromOrder(this.model);
    },

    fetch: function(first, pageSize) {   
      return this.model.getAttachments(first, pageSize);
    },

    uploadItem: function(file) {
      return this.model.uploadAttachment(file);
    },

    deleteItem(attachment) {
      return this.model.deleteAttachment(attachment);
    },

    editItem: function(attachment) {
      App.navigate('attachments/attachments/' + this.model.get('secId') + '/' + attachment.get('secId') + '/commandline', {trigger: true});
    },

    copyItem: function(attachment) {
      this.model.copyAttachmentToCustomer(attachment, this.options.customer.get('secId')).done(_.bind(function(newAttachment) {
        var model = App.request('customer:model', newAttachment);
        this.options.attachmentsView.customerView.addAttachment(model);
      }, this));
    },

    applyItemToComposition: function(attachment) {
      applyAttachmentToComposition(this.model, attachment);
    }
  });

  /**
   * Open the personalisation picker for `order` and, once the user picks one,
   * call the backend's `applyAttachment` endpoint to rewrite that composition's
   * XML around this attachment's file.
   */
  function applyAttachmentToComposition(order, attachment) {
    if(!order || !attachment) return;

    CompositionPickerView.open({
      order: order,
      attachmentName: attachment.get('fileName'),
      onPick: function(composition) {
        var fileUid = extractFileUid(attachment.get('fileLink'));
        if(!fileUid) {
          showNotify(_.i18n('attachments.applyToComposition.noFileUid', null,
            'Could not resolve the file UID for this attachment.'), 'danger');
          return;
        }

        showNotify(_.i18n('attachments.applyToComposition.applying', null,
          'Applying image to the selected personalisation…'), 'info');

        order.applyAttachmentToComposition(composition.secId, fileUid, attachment.get('fileName'))
          .done(function() {
            showNotify(_.i18n('attachments.applyToComposition.success', null,
              'Image applied to the selected personalisation.'), 'success');
            // Refresh the order so the personalisation tab picks up the new XML.
            if(order.fetch) order.fetch();
          })
          .fail(function() {
            showNotify(_.i18n('attachments.applyToComposition.failed', null,
              'Failed to apply image to the selected personalisation.'), 'danger');
          });
      }
    });
  }

  function showNotify(message, type) {
    if(!$.notify) return;
    $.notify({
      message: message
    }, {
      type: type || 'info',
      placement: { from: 'top', align: 'center' },
      delay: type === 'danger' ? 5000 : 3000
    });
  }

  /**
   * fileLink looks like "files/getfile/<uid>?params=t&action=preview&tokenId=...".
   * We want the bare <uid> portion.
   */
  function extractFileUid(fileLink) {
    if(!fileLink) return null;
    var match = fileLink.match(/getfile\/([^?&/]+)/);
    return match ? match[1] : null;
  }
});

